import { createContext, forwardRef, useCallback, useContext } from 'react';

import { Flex } from '@frontend/components';

import { TableContext } from './Table';

export const DEFAULT_CONTEXT = {
  registerCell: () => null,
};

export const RowContext = createContext(DEFAULT_CONTEXT);

export interface RowProps extends BoxProps {
  role?: AriaRole | null;
  index?: number;
}

export const Row = forwardRef(({ index, role = 'row', ...restProps }, ref) => {
  const { setCellData, handleKeyDown } = useContext(TableContext);

  const onSetCellData = useCallback(
    (cell, column) => {
      if (index != null && column != null) {
        setCellData({ row: index, column, ...cell });
      }
    },
    [index, setCellData],
  );

  const onhandleKeyDown = useCallback(
    (event, column) => {
      if (index != null && column != null) {
        return handleKeyDown({ row: index, column, event });
      }
    },
    [handleKeyDown, index],
  );

  return (
    <RowContext.Provider
      value={{ setCellData: onSetCellData, handleKeyDown: onhandleKeyDown }}
    >
      <Flex
        ref={ref}
        role={role !== null ? role : undefined}
        flex={1}
        minW="min-content"
        h="min-content"
        minH={5}
        borderTop="1px solid"
        borderColor="separator.divider"
        {...restProps}
      />
    </RowContext.Provider>
  );
});
Row.displayName = 'Row';

export default Row;
